<template>
  <div
    class="c-serviceImage"
    ref="serviceImageBox"
  >
    <template v-if="moviePriorityFlag && serviceMovie.length">
      <movie-wrap
        :movie="serviceMovie[0]"
        :box-height="boxHeight"
        :box-width="boxWidth"
        :padding-type="paddingType"
        :padding-ratio="paddingRatio"
        :is-modal="isModal"
      />
    </template>

    <template v-else-if="serviceImage.length">
      <div
        class="c-staticImage"
        :style="boxStyle"
      >
        <div
          class="c-staticImage_paddingElement"
          :style="{ paddingTop: `${paddingRatio}%`}"
          v-if="paddingType === 'ratio'"
        ></div>
        <span
          class="c-staticImage_thumbnail"
          :style="wrapperStyle"
        >
          <c-service-image
            :filePath="serviceImage[0].imagePath"
            :get-type="disabledLazyLoad ? 'swiper-immediate' : ''"
            class="c-staticImage_thumbnailImage"
            :class="{ 'c-staticImage_thumbnailImage-disabledLinkEffect': disabledLinkEffect }"
            :get-width="layoutType === 'Block' ? 460 : 230"
            :get-height="layoutType === 'Block' ? 380 : 190"
          />
        </span>
      </div>
    </template>

    <template v-else-if="serviceMovie.length">
      <movie-wrap
        :movie="serviceMovie[0]"
        :box-height="boxHeight"
        :box-width="boxWidth"
        :padding-type="paddingType"
        :padding-ratio="paddingRatio"
        :is-modal="isModal"
      />
    </template>

    <template v-else>
      <!-- TODO: 画像がない場合の画像設定。固定画像なので画像サイズの最適化をおこなう -->
      <div class="c-staticImage">
        <div
          class="c-staticImage_paddingElement"
          :style="{ paddingTop: `${paddingRatio}%`}"
          v-if="paddingType === 'ratio'"
        ></div>
        <span
          class="c-staticImage_thumbnail"
          :style="wrapperStyle"
        >
          <img
            src="@/assets/images/common/no_image_item.png"
            class="c-staticImage_thumbnailImage"
            :class="{ 'c-staticImage_thumbnailImage-disabledLinkEffect': disabledLinkEffect }"
          />
        </span>
      </div>
    </template>
  </div>
</template>
<script>
import CServiceImage from '~/components/atoms/CServiceImage'
import MovieWrap from './components/MovieWrap'

export default {
  name: 'serviceImage',
  components: {
    CServiceImage,
    MovieWrap
  },
  props: {
    serviceId: {
      type: [Number, String],
      default: null
    },
    serviceImage: {
      type: Array,
      default: () => []
    },
    serviceMovie: {
      type: Array,
      default: () => []
    },
    moviePriorityFlag: {
      type: Number,
      default: 0
    },
    layoutType: {
      type: String,
      default: 'List'
    },
    boxWidth: {
      type: [Number, String],
      default: 'auto'
    },
    boxHeight: {
      type: [Number, String],
      default: 'auto'
    },
    paddingType: {
      type: String,
      default: 'ratio'
    },
    // 幅に対する高さの比率
    paddingRatio: {
      type: [Number, String],
      default: 100
    },
    urlRef: {
      type: Object
    },
    isModal: {
      type: Boolean,
      default: false
    },
    disabledLinkEffect: {
      type: Boolean,
      default: false
    },
    disabledLazyLoad: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    boxStyle() {
      if (this.paddingType === 'ratio') {
        return {
          maxWidth: 'auto'
        }
      }
      if (this.paddingType === 'calc') {
        return {
          maxWidth: `${this.boxWidth}px`
        }
      }
      return {}
    },
    wrapperStyle() {
      if (this.paddingType === 'calc') {
        return {
          paddingBottom: `calc(${this.boxHeight} / ${this.boxWidth} * 100%)`,
          maxWidth: `${this.boxWidth}px`,
          maxHeight: `${this.boxHeight}px`
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.c-serviceImage {
  position: relative;

  img {
    width: 100%;
    height: auto;
  }

  /deep/ .c-vuetube {
    &_thumbnailImage {
      min-height: auto;
      width: 100%;
      height: auto;
    }
  }

  .c-staticImage {
    position: relative;
    display: flex;
    overflow: hidden;
    margin: 0 auto;
    width: 100%;
    background: none;

    &_thumbnail {
      display: flex;
      width: 100%;
      height: 0;
    }

    &_thumbnailImage {
      @include link-effect;

      position: absolute;
      top: 50%;
      left: 50%;
      z-index: 1;
      cursor: pointer;
      transform: translate(-50%, -50%);
      &-disabledLinkEffect {
        &:hover {
          opacity: 1;
        }
      }
    }
  }

  /deep/ .c-movieImage {
    &.thumbnail {
      margin: 0 auto;
      border-radius: 3px 3px 0 0;
      background-color: $color-black;
    }
  }
}
</style>
